// import exprEval from 'expr-eval'
// let Parser = exprEval.Parser

class FormulaProcessor {
  constructor (fmla, scope) {
    this.fmla = fmla
    this.scope = scope
    // regular expressions that match different references
    this.refs = {
      cell: /&!\w+\.[A-Z][0-9]+|&!\w+\.\w+\.[A-Z][0-9]+/g, // `A1`
      sheetCell: /&\w+\.[A-Z][0-9]+/g, // `&sheet1.A1`
      subsheetCell: /&\w+\.\w+\.[A-Z][0-9]+/g // `&sheet1.sub1.A1`
    }
  }

  start () {
    let result = this.process(this.fmla.slice(1))
    let limit = 10
    let count = 0

    while (
      this.isCellRef(result) ||
      this.isSheetCellRef(result) ||
      this.isSubsheetCellRef(result)
    ) {
      count++
      result = this.process(result)
      if (count >= limit) {
        break
      }
      if (count >= limit) {
        throw new Error(`Mximum limit reached for formula '${this.fmla}'`)
      }
    }

    let processed

    // if (!/^function/.test(result) && !/\(\)$|\(w+\)$/.test(result)) {
    //   processed = Parser.evaluate(result, this.scope)
    // }

    // if (isNaN(processed)) {
    //   let fnText = `var res; with(__scope) { res = (${result}); }; return res;`
    //   let fn = new Function('__scope', fnText) // eslint-disable-line no-new-func
    //   processed = fn(this.scope)
    // }

    let fnText = `var res; with(__scope) { res = (${result}); }; return res;`
    let fn = new Function('__scope', fnText) // eslint-disable-line no-new-func
    processed = fn(this.scope)

    return processed
  }

  // this function check that formula contain reference like `A1`
  isCellRef (string) {
    if (string.match(this.refs.cell)) return true
    return false
  }

  // this function check that formula contain reference like `sheet1!.A1`
  isSheetCellRef (string) {
    if (string.match(this.refs.sheetCell)) return true
    return false
  }

  // this function check that formula contain reference like `sheet1!.sub1!.A1`
  isSubsheetCellRef (string) {
    if (string.match(this.refs.subsheetCell)) return true
    return false
  }

  returnFromScope (key) {
    let result
    if (~key.indexOf('.')) {
      let sheet = key.slice(0, key.lastIndexOf('.'))
      let cell = key.slice(key.lastIndexOf('.') + 1)
      if (typeof this.scope[sheet][cell] === 'undefined') throw new Error(`Reference error: '${key}' is not defined`)
      result = this.scope[sheet][cell]
    } else {
      if (typeof this.scope[key] === 'undefined') throw new Error(`Reference error: '${key}' is not defined`)
      result = this.scope[key]
    }

    if (result[0] === '=') result = result.slice(1)

    let curRegEx = /^\$(\d{1,3}(\,\d{3})*|(\d+))(\.\d{2})?$/g // eslint-disable-line
    if (curRegEx.test(result)) {
      result = result.replace(curRegEx, (x) => {
        let newVal = x.replace(/\$|\,/g, '') // eslint-disable-line
        return newVal
      })
    }
    return `(${result})`
  }

  process (val) {
    if (this.isCellRef(val)) {
      val = val.replace(this.refs.cell, (x) => {
        x = x.slice(2)
        return this.returnFromScope(x)
      })
    }

    if (this.isSubsheetCellRef(val)) {
      val = val.replace(this.refs.subsheetCell, (x) => {
        x = x.slice(1)
        return this.returnFromScope(x)
      })
    }

    if (this.isSheetCellRef(val)) {
      val = val.replace(this.refs.sheetCell, (x) => {
        x = x.slice(1)
        return this.returnFromScope(x)
      })
    }

    return val
  }
}

export default FormulaProcessor
